"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _replaceAll = _interopRequireDefault(require("./replaceAll"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var sprintf = function sprintf(text, variables) {
  return Object.keys(variables).reduce(function (result, key) {
    return (0, _replaceAll.default)(result, "${" + key + "}", variables[key]);
  }, text);
};
var _default = sprintf;
exports.default = _default;